import addHours from "date-fns/add_hours";
import addMinutes from "date-fns/add_minutes";
import setMinutes from "date-fns/set_minutes";
import getMinutes from "date-fns/get_minutes";
import startOfHour from "date-fns/start_of_hour";
//
import {
  minAdvanceMinutes,
  minAdvanceMinutesLong,
  maxAdvanceHours,
} from "../config";

// Min date
export function getMinDate(isLong = false) {
  const now = new Date();

  let minDate = addMinutes(
    now,
    isLong ? minAdvanceMinutesLong : minAdvanceMinutes
  );
  const minutes = getMinutes(minDate);

  minDate = startOfHour(minDate);

  // Round up to the next quarter
  if (minutes > 45) {
    minDate = addHours(minDate, 1);
  } else if (minutes > 30) {
    minDate = setMinutes(minDate, 45);
  } else if (minutes > 15) {
    minDate = setMinutes(minDate, 30);
  } else if (minutes > 0) {
    minDate = setMinutes(minDate, 15);
  }

  return minDate;
}

// Max date
export function getMaxDate(minDate) {
  return addHours(minDate, maxAdvanceHours);
}
